const PAGE_SIZE = 9;

function initOfferCardAnalytics(card) {
  card.addEventListener('click', () => {
    const title = card.querySelector('.offer-card__title')?.textContent?.trim();

    if (window.dataLayer && title) {
      window.dataLayer.push({
        event: 'offer_card_click',
        offer_title: title,
      });
    }
  });
}

function revealNextItems(items, count) {
  items
    .filter((item) => item.hidden)
    .slice(0, count)
    .forEach((item) => {
      // eslint-disable-next-line no-param-reassign
      item.hidden = false;
      item.classList.remove('offer-card--hidden');
    });
}

function initOffersOverview(rootEl) {
  const grid = rootEl.querySelector('[data-offers-overview-list]');
  const moreContainer = rootEl.querySelector('[data-offers-overview-more]');
  const moreBtn = rootEl.querySelector('[data-offers-overview-more-btn]');

  if (!grid) {
    return;
  }

  const allItems = Array.from(grid.querySelectorAll('[data-offers-overview-item]'));

  allItems.forEach(initOfferCardAnalytics);

  if (!moreBtn || !moreContainer) {
    return;
  }

  moreBtn.addEventListener('click', () => {
    revealNextItems(allItems, PAGE_SIZE);

    const hasHidden = allItems.some((item) => item.hidden);
    if (!hasHidden) {
      moreContainer.hidden = true;
    }
  });
}

function initAll() {
  document.querySelectorAll('.offers-overview').forEach(initOffersOverview);
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds-offers-overview', initAll);
  }

  initAll();
});
